import React from "react";
import Listv1 from "../List/ListV1";
import "./Happening.css";

const Happening = ({ setShowModal }) => {
  return (
    <>
      <div
        className="md:px-20 h-full relative happening-container"
        id="whatHappening"
      >
        <div className="mt-10">
          <div className="content-aside-container text-white relative pt-20">
            <h1 className="text-2xl md:text-4xl mb-4 font-black">
              What’s happening?
            </h1>
            <p className="paragraph md:mb-8">
              Check out the interactive and fun activities lined up for you!
            </p>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col space-y-4 md:flex-row md:space-x-0 md:space-y-0 relative timeline">
        <div className="hidden pt-5 md:block md:w-2/3 lg:w-2/4 relative">
          <img
            src={require("../../Assets/Agenda/01.jpg")}
            className="slider_img_01"
            alt="01"
          />
          <img
            src={require("../../Assets/Agenda/0w.png")}
            className="slider_img_ow"
            alt="0w"
          />
          <div className="slider_img_02">
            <img
              src={require("../../Assets/Agenda/02.jpg")}
              alt="02"
            />
          </div>
        </div>
        <div className="md:w-3/3 lg:w-3/4 timeline-container">
          <div className="content-aside-container text-white relative">
            {/* <div className="dotted-container"></div> */}
            <div className="timeline-section">
              <Listv1 setShowModal={setShowModal} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Happening;
